import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=fcf2b1c8&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=fcf2b1c8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf2b1c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcf2b1c8')) {
      api.createRecord('fcf2b1c8', component.options)
    } else {
      api.reload('fcf2b1c8', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=fcf2b1c8&scoped=true&", function () {
      api.rerender('fcf2b1c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2m4CNGn10TMOl/JS/comp/Paginate.vue"
export default component.exports